export default __webpack_public_path__ + "static/graphic-header-960-c8c2c84e681e69e66ef224ff694eeae2.svg";